// 获取最终的状态信息
export const productname = state => state.productname
export const productlist = state => state.productlist
export const YwwpicRight = state => state.YwwpicRight 
export const YwwLagre = state => state.YwwLagre
export const Xiancai = state => state.Xiancai
export const Baozhuang = state => state.Baozhuang
export const DesignList = state => state.DesignList
export const sum = state => state.sum
export const Pnumber = state => state.Pnumber
export const Allsum = state => state.AllSum
export const SelectDesign = state => state.SelectDesign
export const CustomUplod = state => state.CustomUplod
export const logostylenumber = state => state.logostylenumber
export const logoColornumber = state => state.logoColornumber
export const SumPrice = state => state.SumPrice
export const DesignMake = state => state.DesignMake
export const Childproductlist = state => state.Childproductlist
export const addinfo = state => state.addinfo
export const tabbarList = state => state.tabbarList
export const tokenid = state => state.tokenid
export const ukey = state => state.ukey
export const makelist = state => state.makelist

// export const getDesignList = (state) => {
//     if (localStorage.getItem('newDesginList')) {
//         state.DesignList = localStorage.getItem('newDesginList')
//     }
//     return state.DesignList
// }


// WEBPACK FOOTER //
// ./src/store/getters.js